import { Order } from 'entities/orders/model/types';
import { FC } from 'react';
import { Flex } from 'shared/ui/flex';
import { format } from 'date-fns';

export const OrderCreated: FC<{ order: Order }> = ({ order }) => {
    return (
        <Flex $direction="column" $justify="center" style={{ whiteSpace: 'nowrap', fontSize: '12px', height: '100%' }} $alignItems="center">
            <span>{format(new Date(order.dt_created), 'dd.MM.yyyy')}</span>
            <span>{format(new Date(order.dt_created), 'HH:mm')}</span>
        </Flex>
    );
};
